import { http } from "@/utils/index";

export function uploadImage() {
  return http.request("post", "/upload/image", {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
}

export function saveHomeBanner(data) {
  return http.request("post", "/home/banner", {
    data
  });
}

export function leftLikeDict(key) {
  return http.request("get", "/dict/leftLike", {
    params: {
      key
    }
  });
}

export function leftLikeDicts(keys) {
  return http.request("get", "/dict/leftLikes/" + keys.join(","), {});
}

export function saveDict(data) {
  return http.request("post", "/dict/save", {
    data
  });
}

// 根据前缀删除
export function deleteDict(key) {
  return http.request("delete", "/dict/delete", {
    params: {
      key
    }
  });
}

export function saveChildrenDict(data) {
  return http.request("post", "/dict/children/save", {
    data
  });
}

export function deleteChildrenDict(key) {
  return http.request("delete", "/dict/children/delete", {
    params: {
      key
    }
  });
}

export function getHomeBanner() {
  return http.request("get", "/home/banner", {});
}

// 友情链接
export function getAllLinks() {
  return http.request("get", "/link", {});
}

export function createLink(data) {
  return http.request("post", "/link", {
    data
  });
}

export function deleteLink(id) {
  return http.request("delete", "/link/" + id, {});
}
